import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AboutComponent} from './about.component';
import {RouterModule} from '@angular/router';
import {LayoutModule} from '../../layout/layout.module';
import {TeamMemberCardComponent} from './team-member-card/team-member-card.component';


@NgModule({
    imports: [
        CommonModule,
        RouterModule.forChild([{
                path: '',
                component: AboutComponent,
                data: {
                    title: 'About'
                },
            }]),
        LayoutModule,
        AboutComponent, TeamMemberCardComponent,
    ]
})
export class AboutModule {
}
